import { GetManagementServiceRootUrl, Post } from "./ServiceManager";
import { ServiceResult } from "./ServiceEntities";
import { ContactUsRequestGuest, ContactUsRequestLoggedIn, SubmitEnquiryResponse } from "./ContactUsContracts";

/** Base URL for the ContactController in the Booking Management Service. */
function GetBaseUrl(): string {
    return `${GetManagementServiceRootUrl()}Contact/`;
}

/** Client for the ContactController in the Management API */
class ContactServiceClass {

    /**
     * Submit the contact enquiry for logged in users. The contract is slightly different for logged in users and guests.
     */
    public SubmitEnquiryForLoggedInUser(request: ContactUsRequestLoggedIn): Promise<ServiceResult<SubmitEnquiryResponse>> {
        const url = `${GetBaseUrl()}SubmitForLoggedInUser`;
        return Post<SubmitEnquiryResponse>(url, request);
    }

    /**
     * Submit the contact enquiry for guest users. The contract is slightly different for logged in users and guests.
     */
    public SubmitEnquiryForGuest(request: ContactUsRequestGuest): Promise<ServiceResult<SubmitEnquiryResponse>> {
        const url = `${GetBaseUrl()}SubmitForGuest`;
        return Post<SubmitEnquiryResponse>(url, request);

    }
}

export const ContactService = new ContactServiceClass();